export const PDP_ADDITIONAL_INFO_MIDDLE_SECTION_ESPOT = 'PDP-AdditionalInfo_MiddleSection';
export const PDP_ADDITIONAL_INFO_INFERIOR_SECTION_ESPOT = 'PDP-AdditionalInfo_InferiorSection';
